<template>
  <div class="content">
    <c회원선택 ref="selectCust" @select="selectCust" />
    <s-location apply title="미사용 증표 전환 신청 <small>(명의변경)</small>"/>

    <h4 class="sub_title02">미사용 증표 현황</h4>

      <div class="btn_group mt0">
        <div class="right">
          <button @click="initData" class="btn icon reload">초기화</button>
          <button @click="doSearch" class="btn icon search_black">검색</button>
          <button @click.prevent="$refs.excel.down()" class="btn icon excel">엑셀 다운</button>
        </div>
      </div>
    <table class="tbl01 sch_tbl">
      <tr>
        <th>구입일</th>
        <td>
          <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_selldtfr" :placeholder="search.iv_selldtfr"/>
        ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_selldtto" :placeholder="search.iv_selldtto"/>
        <br class="mobile"/>
          <s-date-range :fr.sync="search.iv_selldtfr" :to.sync="search.iv_selldtto" />
        </td>
      </tr>
      <tr>
        <th>증표 종류</th>
        <td>
          <!-- 공익(B10400), 면제(B10500) 제외 -->
          <c증표종류_검색폼
            :search.sync="search"
            :except_code="except_code"
            @select="doSearch"
          />
        </td>
      </tr>
      <tr>
        <th>증표 번호</th>
        <td>
            <input type="text" v-model="search.iv_rcptnofr_1" class="w_inputno" @keyup.enter="doSearch" v-mask="'#####'" v-on:keyup="$event.target.value.length >= 5 && $event.target.nextElementSibling.focus()"/> -
            <input type="text" v-model="search.iv_rcptnoto_1" class="w_inputno" @keyup.enter="doSearch" v-mask="'######'"/>
        </td>
      </tr>
      <tr>
        <th>검색어</th>
        <td>
          <select v-model="search.iv_ktype">
            <option value="ALL"      >전체</option>
            <option value="MEMBNM"   >증표명의</option>
            <option value="CLIENT"   >위임인</option>
            <option value="OTHERSIDE">상대방</option>
            <option value="REMK"     >비고</option>
          </select>
          <input type="text" class="sch_input" title="검색어" v-model="search.iv_kword" placeholder="검색어" @keyup.enter="doSearch"/>
        </td>
      </tr>
    </table>

    <s-excel
      ref="excel"
      excel-api="/proc_excel/N_VIAINFO_SEL_LIST_EMP"
      excel-filename = "미사용증표"
      :isDebug="false"
      :excel-top ="`

          조회기간 : ${ search.iv_selldtfr } ~ ${ search.iv_selldtto }

      `"
      excel-headers = "
          text           | value            | format
          구입일자       | selldt           | YYYY.MM.DD
          증표명의       | ownernm          |
          증표종류       | org_caseclsfnm   |
          증표번호       | rcptno           | insertHyphen(5)
          비고           | remk             |
      "
      :excel-param = "()=>({
        ...search,
        iv_pgsize      : '-1',
        iv_page        : '1',
    })"/>

    <h4 class="sub_title02">검색 결과</h4>

    <s-loading v-if="list.loading"/>
    <div class="scroll_wrap "> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <!-- 테이블 -->
      <table class="tbl01">
        <thead>
          <tr>
            <th width="30px" >순번</th>
            <th width="60px">구입일자</th>
            <th width="300px">증표명의</th>
            <th width="100px">증표종류</th>
            <th width="90px">증표번호</th>
            <th>비고</th>
            <th width="30px">추가</th>
          </tr>
        </thead>

        <tr v-for="(item,i) in list.items" :key=i :class="{ 'bg_gray01' : !showPlusBtn(item) }">
          <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
          <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
          <td v-html="T.nl_to_br(item.ownernm)"></td>
          <td>{{ item.org_caseclsfnm }}</td>
          <td>{{ item.rcptno | insertHyphen(5) }}</td>
          <td class="al_l">{{ item.remk }}</td>
          <td class="p0">
            <img v-if="showPlusBtn(item)"
                 src="/images/common/icon_plus_blue.png"
                 class="icon_squ"
                 @click="addRow(item)" />
          </td>
        </tr>
      </table>
    </div> <!--scroll_wrap -->

    <!-- paging -->
    <div class="paging">
      <p class="num">
        <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="doSearch"/>
      </p>
    </div>
    <!-- /paging -->

    <h4 class="sub_title02">명의 변경할 증표 현황</h4>

    <div class="scroll_wrap "> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

      <table class="tbl01">
        <thead>
          <tr>
            <th width="30px" >순번</th>
            <th width="60px">구입일자</th>
            <th width="300px">증표명의</th>
            <th width="100px">증표종류</th>
            <th width="90px">증표번호</th>
            <th>비고</th>
            <th width="30px">제거</th>
          </tr>
        </thead>

        <tr v-for="(item,i) in saveList" :key=i>
          <td>{{ i + 1 }}</td>
          <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
          <td v-html="T.nl_to_br(item.ownernm)"></td>
          <!-- <td>{{ item.caseclsfnm  }}</td> -->
          <td>{{ item.org_caseclsfnm  }}</td>
          <td>{{ item.rcptno | insertHyphen(5) }}</td>
          <td class="al_l">{{ item.remk  }}</td>
          <!-- <td><a href="buy_receipt" class="btn xs gray01 outline">추가</a></td> -->
        <td class="p0">
          <img src="/images/common/icon_minus_org.png"
              class="icon_squ"
              @click="delRow(item)">
        </td>
      </tr>
      </table>
    </div> <!--scroll_wrap -->

    <!-- 변경내용 -->
    <h4 class="sub_title02">변경내용</h4>

      <!-- 테이블 -->
      <table class="tbl01 sum">
        <tr>
          <th class="nousename">미사용 증표 인수할 회원 또는 법인명</th>
          <td  class="al_l">
            <input type="text" v-model="sitem.to_membnm" ref="to_membnm" class="w_nm" @keydown.enter="openCustPop" @keydown="initCust">
            &nbsp; {{ clsfToText(sitem.to_membclsf) }} - {{ sitem.to_membno }}
            <!-- <input type="text" :value="clsfToText(sitem.to_membclsf)"   class="w_clsf" disabled> / -->
            <!-- <input type="text" :value="sitem.to_membno"    class="w_no" disabled> / -->
<!--             <br class="mobile"/> -->
            <!-- <input type="text" :value="sitem.to_membaddr"  class="w_addr" disabled> -->
            &nbsp; <button @click="openCustPop" class="btn xs org01">회원선택</button>
          </td>
        </tr>
        <tr>
          <th>전환 사유</th>
          <td class="al_l">
           <select v-model="sitem.reasonclsf">
             <option value="" selected="selected">선택</option>
             <option v-for="item in code.RCH_OWNER"
                    :value="item.value"
                    :key="item.value">{{item.text}}</option>
           </select>
           <input type="text"
                  ref="reasonremk"
                  v-model="sitem.reasonremk"
                  v-if="sitem.reasonclsf == 'ETC'"
                  placeholder="기타사유"
                  class="w50p"/>
          </td>
        </tr>
      </table>

      <!-- //테이블 -->
      <!-- //변경내용 -->
      <div class="btn_group">
        <div class="right">
          <button @click="doInit"   class="btn gray01 outline" >취소</button>
          <button @click="saveItem" class="btn gray01">신청</button> <!-- href="buy_ok" -->
        </div>
      </div>
		</div> <!-- content : width=950px; -->
</template>

<script>
let ui
export default {
  components: {
    "c회원선택"       : require('@/components/c회원선택.vue').default,
    'c증표종류_검색폼' : require('@/components/c증표종류_검색폼.vue').default
  },
  beforeRouteEnter (to, from, next) {

    // https://router.vuejs.org/kr/guide/advanced/data-fetching.html#%ED%83%90%EC%83%89-%ED%9B%84-%EA%B0%80%EC%A0%B8%EC%98%A4%EA%B8%B0

    // getPost(to.params.id, (err, post) => {
    //   next(vm => vm.setData(err, post))
    // })
    next()
  },
  data () {
    return {
      search : {},
      search_init : {
        iv_menu         : 'ch_owner'
      , iv_selldtfr     : ""//this.$moment().subtract(1, 'months').format("YYYY-MM-DD")
      , iv_selldtto     : ""//this.$moment().format("YYYY-MM-DD")
      , iv_statclsf     : "BC0100"     // 미사용건만 출력
      , iv_viadtfr      : ""
      , iv_viadtto      : ""
      , iv_viaplac      : ""
      , iv_caseclsf     : ""
      , iv_rcptnofr_1   : ""
      , iv_rcptnoto_1   : ""
      , iv_rcptnofr     : ""
      , iv_rcptnoto     : ""
      , iv_cntchargdtfr : ""
      , iv_cntchargdtto : ""
      , iv_client       : ""
      , iv_isttoutplac  : ""
      , iv_otherside    : ""
      , iv_linkyn       : ""
      , iv_lostyn       : ""
      , iv_onlineyn     : ""
      , iv_lawyernm     : ""
      , iv_membclsf     : ""
      , iv_membno       : ""
      , iv_membnm       : ""
      , iv_viamembclsf  : ""
      , iv_viamembno    : ""
      , iv_officeclsf   : ""
      , iv_officeno     : ""
      , iv_order_by1    : ""
      , iv_order_by2    : ""
      , iv_order_by3    : ""
      , iv_order_by4    : ""
      , iv_freeclsf     : ""
      , iv_case_b10300  : ""
      , iv_ktype        : "ALL"
      , iv_kword        : ""
      , iv_cancelclsf   : ""
      , iv_searchdtgbn  : ""
      , iv_searchfr     : ""
      , iv_searchto     : ""
      },
      sitem : {},
      sitem_init : {
        reasonclsf  : ''
      , reasonremk  : ''
      , to_membnm   : ''
      , to_membclsf : ''
      , to_membno   : ''
      , to_membaddr : ''
      },
      code: {},
      chkAll : false,
      list: {
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
      except_code : ['B10400', 'B10500'], // 증표종류 검색조건 : 공익(B10500), 면제(B10400) 제외
      saveList : [],
      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    this.search = { ...this.search_init }
    this.sitem  = { ...this.sitem_init }
  },
  mounted() {
    // 공통코드 로드
    ui.codeLoad("RCH_OWNER", code => {
      this.code = code
    });
  },
  methods : {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.sitem  = T.deepCopy(this.sitem_init)
      this.saveList = []
      this.doSearch()
    },
    doInit(){
      this.sitem  = T.deepCopy(this.sitem_init)
      this.saveList = []
    },
    addRow(item) {
      if (this.saveList.filter(e => e.viaregdt == item.viaregdt && e.viaseq == item.viaseq).length > 0) {
        return ui.alert("이미 선택된 증표입니다. 선택 리스트를 확인해 주세요.")
      }

      this.saveList.push(item)
    },
    delRow(item) {
      this.saveList = this.saveList.filter(e => !(e.viaregdt == item.viaregdt && e.viaseq == item.viaseq))
    },
    showPlusBtn(item) {
      return !this.saveList.some(e => e.viaregdt == item.viaregdt && e.viaseq == item.viaseq)
    },
    openCustPop() {
      // 수임일자 오늘로 하고 조회
      let cntchargdt = this.$moment().format("YYYY-MM-DD")
      this.$refs.selectCust.open('', this.sitem.to_membnm, cntchargdt)
    },
    selectCust(item) {
      this.sitem.to_membclsf = item.membclsf
      this.sitem.to_membno   = item.membno
      this.sitem.to_membnm   = item.membnm
      this.sitem.to_membaddr = item.addr
    },
    initCust() {
      this.sitem.to_membclsf = ''
      this.sitem.to_membno   = ''
      this.sitem.to_membaddr = ''
    },
    doSearch() {
      this.search.iv_rcptnofr = this.search.iv_rcptnofr_1 + "" + this.search.iv_rcptnoto_1
      this.search.iv_rcptnoto = this.search.iv_rcptnofr

      ui.httpGetList(this.list
        , '/proc/N_VIAINFO_SEL_LIST_EMP'
        , {
          ...this.search
          , iv_pgsize      : this.list.listSize
          , iv_page        : this.list.pageNo
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })
    },
    saveItem() {

      // 필수체크
      if (this.saveList.length == 0) return ui.alert("명의변경할 증표를 추가해 주세요.")
      if (ui.chkEmpty("sitem.to_membno" , "미사용 증표 인수할 회원 또는 법인명을 선택해 주세요", "to_membnm")) return
      if (ui.chkEmpty("sitem.reasonclsf", "전환사유를 선택해 주세요")) return
      if (this.sitem.reasonclsf == 'ETC' &&
          ui.chkEmpty("sitem.reasonremk", "전환사유를 직접입력으로 선택하신 경우 기타사유를 입력하셔야 합니다.", "reasonremk")) return

      ui.confirm('신청하시겠습니까 ?', "신청확인")
        .then(r => r && this.itemUpdate())

    },
    itemUpdate() {
      this.saveList.some((item, i) => {
        this.sitem.viaregdt = ((i == 0) ? '' : this.sitem.viaregdt + '#') + item.viaregdt
        this.sitem.viaseq   = ((i == 0) ? '' : this.sitem.viaseq   + '#') + item.viaseq
      })

      // 변경 회원
      this.sitem.to_membclsf = this.sitem.to_membclsf || ''
      this.sitem.to_membno   = this.sitem.to_membno   || ''

      ui.httpPost("/proc_iv/N_VIASTAT_UPD",
      {
        ...this.sitem
        , viastatclsf  : 'CH_OWNER'
        , approveclsf  : 'REQ'
        , approvemsg   : ''
        , viastatdt    : ''
        , viastatseq   : ''
        , viastatdtlid : ''
        , caseclsf     : ''
        , to_caseclsf  : ''
        , to_casetype  : ''
        , to_viafee    : 0
        , to_amt       : 0
        , rf_amt       : 0
        , rfway        : ''
        , rfbankcode   : ''
        , remk         : ''
        , rfaccno      : ''
        , rfaccname    : ''
        , attachid     : ''
        , attachid2    : ''
      },
      ret => {
        const {msg, status, sellregdt ,sellseq} = ret.data.rs1[0];
        ui.notify(msg);

        if (status == '0') { // 작업이 정상 완료일때 신청내역 페이지로 이동
           this.$router.push({ path: 'stat_list' })
        }

      })
    },
    clsfToText(v) {
      switch(v) {
        case 'P' : return "개인"
        case 'B' :
        case 'C' : return "법인"
        case 'J' : return "공동"
        case 'D' : return "공동"
      }
      return v
    },
  }
}
</script>
<style scoped>
  /* 명의변경신청 */
  .tbl01.sum th.nousename { width:300px;}

  .w_nm { width:180px !important;}
  .w_clsf { width:50px!important;}
  .w_no { width:60px!important; text-align: center; }
  .w_addr { width:200px!important;}

  @media screen and (max-width:640px){
    .w_nm { width:180px !important;}
    .tbl01 tr td input, .tbl01 tr td button { margin-bottom:10px; display: inline; max-width: 100px;;}
    .tbl01.sum th.nousename { width:80px;}
    .tbl01.sum input, .w_nm { max-width: 100%; display: block; width:100% !important;}
  }
</style>